export var ActionTypes;
(function (ActionTypes) {
    ActionTypes[ActionTypes["PATIENT_SELECTED"] = 0] = "PATIENT_SELECTED";
    ActionTypes[ActionTypes["RELOAD_TOP_MENU"] = 1] = "RELOAD_TOP_MENU";
    ActionTypes[ActionTypes["USER_LOGIN"] = 2] = "USER_LOGIN";
    ActionTypes[ActionTypes["USER_LOGOUT"] = 3] = "USER_LOGOUT";
    ActionTypes[ActionTypes["MODIFIED_UPDATE"] = 4] = "MODIFIED_UPDATE";
    ActionTypes[ActionTypes["EVENT_SAVED"] = 5] = "EVENT_SAVED";
    ActionTypes[ActionTypes["TOAST_MESSAGE"] = 6] = "TOAST_MESSAGE";
    ActionTypes[ActionTypes["REFRESH_VERTICAL_TAB"] = 7] = "REFRESH_VERTICAL_TAB";
    ActionTypes[ActionTypes["RELOAD_CONTENT_TAB"] = 8] = "RELOAD_CONTENT_TAB";
})(ActionTypes || (ActionTypes = {}));
